module.exports = __webpack_public_path__ + "static/media/dropdown.f2a846c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/dropdown.svg
// module id = 1703
// module chunks = 50